export var environment = {
    production: false,
    environment: 'dev',
    apiUrl: 'http://localhost:8086',
    appTitle: '论文格式处理工具',
    uploadMaxSize: 50, // MB
    enableDebug: true,
    logLevel: 'debug',
    apiTimeout: 30000, // ms
    fileDownloadExpiration: 24, // hours
    // FeedbackMail SDK配置
    feedbackSdk: {
        baseUrl: 'http://localhost:8089',
        apiKey: 'fb_default_api_key_change_me',
        websiteName: 'formatter',
        buttonIcon: '🎧',
        buttonText: '意见反馈',
        position: 'bottom-right',
        timeout: 30,
        language: 'zh',
        debug: true
    },
    // Feature flags
    features: {
        advancedProcessing: true,
        debugPanel: true,
        testingTools: true,
    }
};
